import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import MUITextFieldStyle from '../../../MUIStyles/MUITextFieldStyle';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '../../../Alert';
import AlertConfirm from '../../AlertConfirm';
import ChooseParcel from './ChooseParcel';

// Queries
import AvalaraResolveAddress from '../../../Queries/AvalaraResolveAddress';
import postGlobal from '../../../Queries/postGlobal';

// Objects
import usStates from '../../../Queries/usStates';

// Styles
import styles from './index.module.sass';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

export default function ReshipmentAddressForm({
  setSessionMessage,
  history,
  device,
  callback,
  order,
  setReshipmentAddress,
  blackList = false,
}) {
  const { t } = useTranslation(['address', 'reshipments', 'order']);
  console.log(device.screenSize, 'device');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [form, setForm] = useState({
    Ciudad: order?.Ciudad || '',
    CodigoPostal: order?.CodigoPostal || '',
    Estado: order?.Estado || '',
    Firma: order?.Firma || '0',
    Line1: `${order?.Line1 || ''} ${order?.Line2 || ''} ${order?.Line3 || ''}`,
    Pais: 'US',
    Paqueteria: order?.Paqueteria || '',
  });
  const [nextRoute, setNextRoute] = useState('');
  const [checked, setChecked] = useState(order?.Firma === '1');
  const [openWarning, setOpenWarning] = useState(false);
  const [notVerifiedChecked, setNotVerifiedChecked] = useState(false);

  const screenSize = device?.screenSize || 'desktop';

  const handleChange = (e, type) => {
    setForm((oldValue) => {
      if (e.target.name === 'Estado' && e.target.value === 'PR') {
        oldValue.Paqueteria = 'USPS';
      }

      return { ...oldValue, [e.target.name]: e.target.value };
    });
  };

  const handleCheck = (event) => {
    setChecked(event.target.checked);
  };

  const handelDialog = useCallback(
    (action, mensaje, route) => {
      if (mensaje) setAlertText(mensaje);
      setOpen(action);
      if (route) setNextRoute(route);
      if (!action && nextRoute) history.push(nextRoute);
    },
    [history, nextRoute],
  );

  async function verifyAddress() {
    const resp = await AvalaraResolveAddress({
      jsonBody: {
        line1: form?.Line1 || '',
        line2: '',
        city: form?.Ciudad || '',
        region: form?.Estado || '',
        postalCode: form?.CodigoPostal || '',
        country: 'US',
      },
    });

    const { message, tipoMensaje, validatedAddresses = [] } = resp;
    const { addressType = '' } = validatedAddresses[0] || {};
    if (addressType === 'POBoxAddress') {
      setAlertText('PO BOX addresses are not allowed');
      setOpen(true);
    } else if (
      notVerifiedChecked ||
      (tipoMensaje === 'success' && addressType !== 'POBoxAddress' && validatedAddresses[0])
    ) {
      const { city, line1, line2, region, postalCode } = validatedAddresses[0];

      // if (region === 'MT') {
      //   setAlertText(t('address:montanaAlert'));
      //   setOpen(true);
      // } else {
      setForm((oldValue) => {
        return {
          Line1: `${line1 || ''} ${line2 || ''}`,
          Estado: region,
          Colonia: region,
          Ciudad: city,
          CodigoPostal: postalCode,
        };
      });

      const response = await postGlobal({
        tmbservice: 'actualizarDomicilioReenvio',
        jsonBody: {
          idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          pedido: order.Pedido || '',
          direccion1: form?.Line1 || '',
          direccion2: '',
          direccion3: '',
          ciudad: form?.Ciudad || '',
          estado: form?.Estado || '',
          CP: form?.CodigoPostal || '',
          pais: 'USA',
          paqueteria: form?.Paqueteria,
          firma: checked ? '1' : '0',
        },
      });

      const { typeMessage = 'error', message = '', dataDetalleReenvio = {} } = response;

      setSessionMessage(message);

      // if (message !== '498' && message !== '499') handelDialog(true, message, redirect);

      if (typeMessage === 'success') {
        setForm({});
        window.scrollTo(0, 0);
        setReshipmentAddress(dataDetalleReenvio);
        if (callback) callback();
      }
      // }

      return true;
    } else if (tipoMensaje === 'inspect') {
      // alert(tipoMensaje);
      handelDialog(true, message);
      return false;
    } else {
      // alert('Validation error');
      handelDialog(true, 'Validation error');
      return false;
    }
  }

  async function verifyAndPost() {
    setLoading(true);

    await verifyAddress();

    setLoading(false);
  }

  async function confirmCallback() {
    setConfirmOpen(false);
    await verifyAndPost();
  }

  async function handleSubmit() {
    if (!checked && !blackList) {
      setConfirmText(t('order:shippingChargeAlert'));
      setConfirmOpen(true);
      return;
    }

    if (!form?.Paqueteria) {
      setAlertText(t('reshipments:noParcelSelected'));
      setOpen(true);
      return;
    }

    verifyAndPost();

    return true;
  }

  function parcelCallback(paqueteria) {
    setForm((oldValue) => {
      return {
        ...oldValue,
        Paqueteria: paqueteria,
      };
    });
  }

  useEffect(() => {}, [form]);

  return (
    <div className={styles.AddressForm}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handelDialog(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogContent>
          <div className={styles.dialogContent}>
            <div className={styles.dialogTitle}>Terramar</div>
            {alertText}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handelDialog(false)} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Alert
        cancel
        open={openWarning}
        setOpen={setOpenWarning}
        title={t('address:warningText')}
        text={t('address:verifyWarning')}
        callback={() => {
          setNotVerifiedChecked(true);
        }}
      />

      <AlertConfirm
        openConfirm={confirmOpen}
        setOpenConfirm={setConfirmOpen}
        title='Warning'
        text={confirmText}
        callback={confirmCallback}
        setLoading={setLoading}
      />

      <div className={`${styles.container} ${styles[screenSize]}`}>
        <div className={`${styles.inputContainer} ${styles.size50} ${styles.paddingRight}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-calle-input'
            label={t('address:address1')}
            type='text'
            name='Line1'
            variant='outlined'
            value={form?.Line1 || ''}
            onChange={(e) => handleChange(e)}
            inputProps={{ maxLength: 40 }}
          />
        </div>

        <div className={`${styles.inputContainer}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-municipio-input'
            label={t('address:city')}
            type='text'
            name='Ciudad'
            variant='outlined'
            value={form?.Ciudad || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingRight}`}>
          <select
            className={styles.inputSelect}
            onChange={(e) => handleChange(e)}
            name='Estado'
            maxLength='34'
            value={form?.Estado || ''}>
            <option value=''>{t('address:state')}</option>
            {usStates.map((val, key) => {
              const { code = '', name = '' } = val;
              return (
                <option value={code} key={key}>
                  {name}
                </option>
              );
            })}
          </select>
        </div>

        <div className={`${styles.inputContainer} ${styles.size50}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-cp-input'
            label={t('address:postalCode')}
            type='text'
            name='CodigoPostal'
            variant='outlined'
            value={form?.CodigoPostal || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        {!blackList && (
          <div className={styles.checkContainer}>
            <Checkbox checked={checked} onChange={handleCheck} />
            <span>{t('reshipments:signatureOnly')}</span>
          </div>
        )}
      </div>

      <ChooseParcel
        state={form?.Estado || ''}
        callback={parcelCallback}
        selected={form?.Paqueteria || ''}
      />

      <div className={styles.formFooter}>
        <div className={styles.button}>
          <Button
            type='submit'
            variant='contained'
            size='large'
            color='primary'
            className={(loading && styles.disabled) || styles.actionButton}
            onClick={() => {
              handleSubmit();
            }}
            disabled={loading}>
            {(loading && <CircularProgress className={styles.circularProgress} />) ||
              t('address:saveChanges')}
          </Button>
        </div>
      </div>
    </div>
  );
}
